import { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion, useTransform, useSpring, useScroll, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../css/sections.css'

import car9x16 from '../assets/about9x16.jpg'
import car2000 from '../assets/about2000.jpg'

const AboutSection = ({ windowWidth }) => {

const [ ref, inView ] = useInView()
const [ about, setAbout ] = useState(false)
const targetRef = useRef()
const animation = useAnimation()
const animation2 = useAnimation()
const animation3 = useAnimation()


const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"]
})

const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 20,
    mass: 0.2
  });

const y = useTransform(smoothProgress, [0, 1], [-100, 100])

useEffect(() => {
if(!inView) {
    animation.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
    animation2.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
    animation3.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
} else {
    animation.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.3 } })
    animation2.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.45 } })
    animation3.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.6 } })
    }
}, [inView])



return (
    <>
    <Link to='/about'>
    <div ref={ targetRef } onMouseEnter={ () => setAbout(true) } onMouseLeave={ () => setAbout(false) } style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden', backgroundColor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        { windowWidth < 700 ? 

        <motion.img src={ car9x16 } style={{ width: '115%', height: '115%', objectFit: 'cover', objectPosition: '50% 50%', position: 'absolute', y }} />

        :

        <motion.img src={ car2000 } style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: '50% 15%', position: 'absolute', y }} />

        }
        
        <div className='general-grid' style={{ position: 'relative' }}>
            <div></div>
            <div>
                <div ref={ ref } style={{ position: 'absolute', bottom: '5rem', lineHeight: '2.8em', filter: 'blur(0.5px)' }}>
                    <div style={{ overflow: 'hidden', height: '18px' }}>
                        <motion.h5 className='little' animate={ animation } style={{ position: 'relative' }}>VISUALIZE IT</motion.h5>
                    </div>
                    <motion.div animate={ about ? { color: '#ffffff' } : { color: '#fff000' } }  className='font-sizes' style={{ marginTop: '0.05em', position: 'relative', color: '#fff000' }}>
                        <div style={{ overflow: 'hidden' }}><motion.div animate={ animation2 }>ABOUT</motion.div></div>
                        <div style={{ overflow: 'hidden' }}><motion.div animate={ animation3 }>GALANTIS</motion.div></div>
                    </motion.div>
                </div>
            </div>
            <div></div>
        </div>
    </div>
    </Link>
    
    </>
)
}

export default AboutSection 